// Supplement-channel type and zero-default for roll cards.
// The resolve/roll handlers always send a modifiers object — currently always
// the zero default. Future feature-specific controls (spend inspiration →
// advantage, Bardic Inspiration die, etc.) should SPREAD this default to build
// an overridden copy (`{ ...DEFAULT_MODIFIERS, advantage: true }`) before
// passing it to the kernel-facing payload shape — never mutate it in place.

export type PlayerModifiersState = {
  flatBonus: number;
  advantage: boolean;
  disadvantage: boolean;
  bonusDice: number[];
};

// Frozen: this is a shared exported singleton passed directly into resolve
// payloads, so an accidental in-place mutation would pollute the default for
// every card. The freeze enforces the spread-to-override pattern above.
export const DEFAULT_MODIFIERS: PlayerModifiersState = Object.freeze({
  flatBonus: 0,
  advantage: false,
  disadvantage: false,
  bonusDice: [],
});
